import { eventData } from "../data.js";
import { useState } from "react";

const Event = () => {
  let [name] = useState(eventData);
  return (
    <>
      <h1>특별한 날</h1>
      <div className="container">
        <div className="row">
          {name.map((item, i) => {
            return <Card name={name[i]} i={i + 19} />;
          })}
        </div>
      </div>
    </>
  );
};

const Card = (props) => {
  return (
    <>
      <div className="col-md-4">
        <img
          style={{ height: "30vh" }}
          src={"/images/" + props.i + ".jpg"}
          alt={props.i}
          width="100%"
        />
        <p />
        <h4>{props.name.title}</h4>
      </div>
    </>
  );
};

export default Event;
